export function formatInboundGroupNames(groups) {
  const names = (groups || []).map((g) => (g && g.name) || "").filter(Boolean);
  return names.length ? names.join(", ") : "—";
}

export function toggleInboundGroupId(ids, id, on) {
  const cur = Array.isArray(ids) ? ids.filter(Boolean) : [];
  if (!id) return cur;
  if (on) return cur.includes(id) ? cur : [...cur, id];
  return cur.filter((x) => x !== id);
}

export function inboundGroupIdsOf(groups) {
  return (groups || []).map((g) => g && g.id).filter(Boolean);
}

export function normalizeInboundGroups(raw) {
  if (raw && Array.isArray(raw.available)) {
    const selected = Array.isArray(raw.selected) ? raw.selected : [];
    const selectedIds = Array.isArray(raw.selected_ids)
      ? raw.selected_ids
      : inboundGroupIdsOf(selected);
    return { available: raw.available, selected, selected_ids: selectedIds };
  }
  if (Array.isArray(raw)) {
    return { available: raw, selected: raw, selected_ids: inboundGroupIdsOf(raw) };
  }
  return { available: [], selected: [], selected_ids: [] };
}
